import React, {useContext} from 'react';
import {OpenApiContext} from '../../openapi-context';
import {List, Tag} from 'antd';
import {Link, useRouteMatch} from 'react-router-dom';

export function Overview({version, checkMobileView}) {
    const {state} = useContext(OpenApiContext);
    const {params} = useRouteMatch('/:env/standards/:category/:key/:version?/:view?/:sectionKey?');

    const nav = [
        {
            key: '',
            title: 'Overview',
            icon: <Tag color="orange">info</Tag>,
        },
        {
            key: 'contact',
            title: 'Contact Infos',
            icon: <Tag color="orange">info</Tag>,
        },
        {
            key: 'license',
            title: 'License',
            icon: <Tag color="orange">info</Tag>,
        },
        {
            key: 'servers',
            title: 'Servers',
            icon: <Tag color="orange">info</Tag>,
        },
    ];

    const active = (item) => params.modelKey === item.key && params.view === 'models';

    const changeMobileView = () => {
        if (checkMobileView) {
            checkMobileView();
        }
    };

    return (
        <div className="scrollable">
            <List
                itemLayout="horizontal"
                size="small"
                rowKey="key"
                dataSource={nav}
                renderItem={(item) => (
                    <List.Item>
                        <List.Item.Meta
                            title={
                                <Link
                                    disabled={state.editMode}
                                    className={active(item) ? 'active' : ''}
                                    to={`/${params.env}/standards/${params.category}/${params.key}/${version}/overview/${item.key}`}
                                    onClick={changeMobileView}>
                                    {item.title}
                                </Link>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
}
